@if (video) {
  <div class="video-card" [style.backgroundImage]="'url(' + backgroundImg + ')'">
    <p-button [icon]="'pi pi-play'" (onClick)="onPlayClick()"></p-button>
  </div>
}
